import api from "../apiInstance"
import { CheckoutPricesResponse, ConfirmPaymentResponse, PaymentMethodOption, PaymentStatusResponse } from "./interfaces/Payment"
import { ProductCheckoutModel } from "./interfaces/Product";

export const getPaymentOptions = async (): Promise<PaymentMethodOption[]> => {
    const res = await api.get<PaymentMethodOption[]>(process.env.REACT_APP_RENTIC_API_URL! + '/products/payment_methods');
    return res.data;
}

export const confirmPayment = async (orderId: number, orderToken: string): Promise<ConfirmPaymentResponse> => {
    const res = await api.post<ConfirmPaymentResponse>(process.env.REACT_APP_RENTIC_API_URL! + '/products/confirm_payment/' + orderId.toString(), {paymentToken: orderToken});
    return res.data;
}

export const getStripePaymentStatus = async (sessionId: string): Promise<ConfirmPaymentResponse> => {
    const res = await api.get<ConfirmPaymentResponse>(process.env.REACT_APP_RENTIC_API_URL! + '/products/get_payment_session_status?session_id=' + sessionId);
    return res.data;
}

export const getEstoPaymentStatus = async (orderId: string): Promise<ConfirmPaymentResponse> => {
    const res = await api.get<ConfirmPaymentResponse>(process.env.REACT_APP_RENTIC_API_URL! + '/products/get_esto_payment_status/' + orderId);
    return res.data;
}

export const getCheckoutPrices = async (productData: ProductCheckoutModel): Promise<CheckoutPricesResponse> => {
    const res = await api.post<CheckoutPricesResponse>(process.env.REACT_APP_RENTIC_API_URL! + '/products/checkout_prices', productData);
    return res.data;
}